var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Allow',{attrs:{"title":"Рассылка сообщений, управление и виджет в группе отключены","content":_vm.content},on:{"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }